import React from "react";
import { useSelector } from "react-redux";
import { RetentionForm } from "components/RetentionForm/RetentionForm";
import { MONTHLY_CLOSING_LABELS } from "./labels";

const { modals, buttons } = MONTHLY_CLOSING_LABELS;

export function MonthlyClosingForm({ open, onClose, data, isClose = false }) {
  const { station, month, year } = useSelector(({ monthlyClosing }) => monthlyClosing);

  return (
    <RetentionForm
      open={open}
      onClose={onClose}
      station={station}
      month={month}
      year={year}
      isClose={isClose}
      isMultiple={!isClose}
      data={data}
      title={isClose ? modals.manualClose : modals.otherClose}
      submitBtnText={buttons.create}
    />
  );
}
